import api from "../utils/api";

const API_URL = process.env.REACT_APP_API_URL;

// Get all clients
export const getClients = async () => {
  const response = await api.post(`${API_URL}/clients.php`, { action: "getAll" });
  return response.data.clients;
};

// Get a single client by ID
export const getClientById = async (id) => {
  const response = await api.post(API_URL, { id, action: "get" });
  return response.data;
};

// Add a new client
export const addClient = async (clientData) => {
  const response = await api.post(API_URL, { ...clientData, action: "add" });
  return response.data;
};

// Update an existing client
export const updateClient = async (clientData) => {
  const response = await api.post(API_URL, { ...clientData, action: "update" });
  return response.data;
};

// Delete a client
export const deleteClient = async (id) => {
  const response = await api.post(API_URL, { id, action: "delete" });
  return response.data;
};
